<template>
  <div class="calico-radio">
    <label
      class="body--medium"
      :class="{ error, disabled }"
    >
      <input
        type="radio"
        :value="value"
        :checked="isChecked"
        :disabled="disabled"
        @input="handleInput"
      >
      <i
        class="bi bi-circle-fill"
        :class="{ error }"
      />
      <span>
        <slot />
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "CalicoRadioButton",
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    modelValue: {
      type: [String, Number],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isChecked() {
      return this.modelValue === this.value;
    },
  },
  methods: {
    handleInput() {
      if (!this.disabled) {
        this.$emit("update:modelValue", this.value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.calico-radio {
  label {
    @include inline-space($space-small);
    user-select: none;
    align-items: center;
    width: fit-content;


    input {
      opacity: 0;
      position: absolute;
    }

    .bi {
      display: flex;
      flex-shrink: 0;
      height: $icon-medium;
      width: $icon-medium;
      align-items: center;
      justify-content: center;
      border: $border-width-default solid $color-neutral-light;
      border-radius: $radius-round;
      box-sizing: border-box;
      background: $color-white;
      &::before {
        display: none;
        font-size: 14px;
      }
    }

    input:checked ~ .bi {
      border: $border-width-default solid $color-black;
      &::before {
        display: block;
      }
    }

    input:checked ~ span {
      color: $color-black;
    }

    span {
      flex: 1;
    }
  }

  .disabled {
    color: $color-neutral-light;
    .bi {
      border: $border-width-default solid $color-neutral-light;
      background: $color-neutral-light;
    }
  }

  .error {
    color: $color-semantics-error;
    border-color: $color-semantics-error;
    .bi {
      border: $border-width-default solid $color-semantics-error;
    }
  }
}
</style>
